import { readonly, Ref, ref } from 'vue';
import { infuse } from '../ioc-config';
import { Route } from '../router/types';

/**
 * Temporary wrapper functions to use vue-router composition function like syntax
 * before we can use the official API after moving to vue-router 4.x (after upgrade to Vue 3)
 */
const reactiveRoute = ref<Route>();

export const useRouter = () => infuse('router');

export const useRoute = () => {
  const router = infuse('router');

  if (!reactiveRoute.value) {
    reactiveRoute.value = router.getCurrentRoute();
    router.onRouteChange((to) => (reactiveRoute.value = to as Route));
  }

  return readonly(reactiveRoute) as Readonly<Ref<Route>>;
};
